import { FormControlLabel, Switch } from "@mui/material";
import theme from "../LayoutComponents/theme";

export default function RadioSelect({ value, label, onChange }) {
  return (
    <FormControlLabel
      control={
        <Switch
          checked={!!value}
          onChange={(e) => onChange(e.target.checked)}
          sx={{
            "& .MuiSwitch-switchBase.Mui-checked": {
              color: theme.colors.purple,
            },
            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
              backgroundColor: theme.colors.purple,
            },
          }}
        />
      }
      label={label}
    />
  );
}
